<template>
  <div class="page-act8-banner" v-bind:style="{'display':towerShow}">    
    <div class="main" style="background-image:url(static/img/act/8/banner/river.png)" >
       <!-- 云 begin -->
        <img class="act-8-banner-cloud-2 act-8-animation-cloud-2" src="static/img/act/8/banner/cloud-1.png">  
        <img class="act-8-banner-cloud-3 act-8-animation-cloud-3" src="static/img/act/8/banner/cloud-1.png">          
        <img class="act-8-banner-cloud-1 act-8-animation-cloud-1" src="static/img/act/8/banner/cloud-1.png">          
      <!-- 云 over --> 

      <div class="tower-wrap" v-bind:style="{'margin-top':marginTop}">
        <img class="tower" src="static/img/act/8/banner/tower.png">
        <!-- 游泳，桂人 begin -->
        <span class="act-8-banner-guiren-wrap act-8-animation-guiren-swim-y" v-bind:style="{'display':liurenShow}">
          <span class="act-8-animation-guiren-swim-x">
            <img class="act-8-banner-guiren-title act-8-animation-guiren-swim-guiren-title-x" src="static/img/act/8/guiren-title.png"/>  
            <img class="act-8-banner-guiren act-8-animation-bounce" src="static/img/act/8/banner/guiren.png">  
          </span>
        </span> 
        <!-- 游泳，桂人 over --> 
      
        <!-- 游泳，柳人 begin -->
        <span class="act-8-banner-liuren-wrap act-8-animation-swim-liuren-y"  v-bind:style="{'top':liurenTop,'display':liurenShow}">
          <span class="act-8-animation-swim-liuren-x">
            <img class="act-8-banner-liuren-title act-8-animation-bounce act-8-animation-swim-liuren-title-x" src="static/img/act/8/liuren-title.png"/> 
            <img class="act-8-banner-liuren act-8-animation-bounce" src="static/img/act/8/banner/liuren.png">  
          </span>
        </span>
        <!-- 游泳，柳人 over -->
      </div>

      <div class="act-8-banner-title-wrap">
        <img class="act-8-banner-title-bg " src="static/img/act/8/banner/title-bg.png">  
        <router-link to="/act8/main">
          <img class="act-8-banner-btn-go act-8-animation-btn-go" src="static/img/act/8/banner/btn-go.png"> 
        </router-link>  
      </div>  
        <img class="mount" src="static/img/act/8/banner/mount.png">
    </div>    
  </div>
</template>
 

<script>
import NavTabbar from '@/components/NavTabbar.vue' 

//动画
import Velocity from "velocity-animate";

export default {
  name: "Act6Banner",
  components: {
    'nav-tabbar': NavTabbar,    
  },
  data() {
    return {
      isShow:false,
      isA:false,
      marginTop:"0%",
      liurenTop:'106%',
      guirenShow:'none',
      liurenShow:'none',
      towerShow:'block',
      
    };
  },
  mounted() {
    let vm = this
    setTimeout(() => {
      vm.isA = true
    }, 15000);

    //解决动画bug
    setTimeout(() => {
      vm.towerShow = 'none'
    }, 1000); 
    setTimeout(() => {
      vm.towerShow = 'block'
    }, 1100); 
    setTimeout(() => {
      vm.liurenShow = 'block'
      vm.guirenShow = 'block'
    }, 1100); 


  },
  created() {   
    if(document.documentElement.clientHeight<=604){
    
      this.marginTop = '-20%'
      this.liurenTop = '100%'
    }
    if(document.documentElement.clientHeight<=554){
      this.marginTop = '-32%'
      this.liurenTop = '100%'
    }
    let vm = this
    //移除loading
    if(this.removeLoader()){
      setTimeout(function(){
        vm.isShow = true
      },2000)   
    } else {
      vm.isShow = true
    }
  /*  this.setDocumentV2(
      "桂人游柳 柳人游柳",
      "",
      "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/8/share.jpg?v=2"
    );*/
    _czc.push(['_trackEvent', '桂人游柳 柳人游柳', '点击', 'Banner页面','0','8']);  
    //动画

  },
  methods: {
    handleVeforeEnter: (el) => {
      //console.log('动画开始前')
      //el.style.opacity = 0   
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {  
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  height: 100%;
  background-position: 50% !important;
  background-size: cover !important;
  overflow: hidden;
}


/* 大标题 */

.act-8-banner-title-wrap {
  position: absolute;
  width: 47%;
  right: 8%;
  top: 11%;
  z-index: 3;
}

.act-8-banner-title-bg {
  position: relative;
  width: 100%;
}



 
@-webkit-keyframes act-7-fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes act-7-fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
.act-7-animation-banner-title {
  -webkit-animation-name: act-7-fadeIn;
  animation-name: act-7-fadeIn;
  -webkit-animation: act-7-fadeIn 0.8s ease-in-out both;
  -moz-animation: act-7-fadeIn 0.8s ease-in-out both;
  animation: act-7-fadeIn 0.8s ease-in-out both;
}

 
 
.act-7-banner-title {
    position: absolute;
    top: 8%;
    left: 6%;
    width: 88%;
    max-width: 100%;
}

.act-7-animation-banner-title-desc {
  -webkit-animation-name: act-7-fadeIn;
  animation-name: act-7-fadeIn;
  -webkit-animation: act-7-fadeIn 0.8s ease-in-out both;
  -moz-animation: act-7-fadeIn 0.8s ease-in-out both;
  animation: act-7-fadeIn 0.8s ease-in-out both;
  animation-delay: 300ms;
  -webkit-animation-delay: 300ms;
}

 
.act-7-banner-title-desc {
    position: absolute;
    top: 57%;
    left: 6%;
    width: 67%;
    max-width: 100%;
}
/* 大标题 end */

/* ACT-8 ‘点击开始’ 按钮 */
@keyframes act-8-frames-btn-go {
  60% { 
    -webkit-transform: scale(1);
    transform:  scale(1);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  }
  70% {
    -webkit-transform: scale(0.8);
    transform:  scale(0.8);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  }
  80% { 
    -webkit-transform: scale(1);
    transform:  scale(1);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  } 
  90% {
    -webkit-transform: scale(0.8);
    transform:  scale(0.8);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  }
  100% {
    -webkit-transform: scale(1);
    transform:  scale(1);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  }
}


.act-8-animation-btn-go {
  -webkit-animation-name: act-8-frames-btn-go;
  animation-name: act-8-frames-btn-go;
  -webkit-animation: act-8-frames-btn-go 2.5s ease-in-out infinite;
  -moz-animation: act-8-frames-btn-go 2.5s ease-in-out infinite;
  animation: act-8-frames-btn-go 2.5s ease-in-out infinite;
}

.act-8-banner-btn-go{    
  position: absolute;
  top: 84%;
  left: 0%;
  width: 55%;
  max-width: 100%;
  z-index: 2;
} 

/* ACT-8 ‘点击开始’ 按钮 over */
 
 

/* ACT-8 游泳，桂人 */ 

@-webkit-keyframes act-8-frames-bounce {
  0%, 50%, 100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  25% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
  }
  75% {
    -webkit-transform: translateY(-3px);
    transform: translateY(-3px);
  }
}
@keyframes act-8-frames-bounce {
  0%, 50%, 100% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  25% {
    -moz-transform: translateY(-5px);
    -ms-transform: translateY(-5px);
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
  }
  75% {
    -moz-transform: translateY(-3px);
    -ms-transform: translateY(-3px);
    -webkit-transform: translateY(-3px);
    transform: translateY(-3px);
  }
}


@-webkit-keyframes act-8-frames-swim
{
	0% { -webkit-transform: translateY(0%)  translateX(0); transform: translateY(0%)  translateX(0); }
	33% { -webkit-transform: translateY(-50%)  translateX(100%); transform: translateY(-50%)  translateX(100%); }
	66% { -webkit-transform: translateY(-90%)  translateX(200%); transform: translateY(-90%)  translateX(200%); }
	100% { -webkit-transform: translateY(-120%)  translateX(350%); transform: translateY(-120%)  translateX(350%); }
 
    
}
@keyframes act-8-frames-swim
{
	0% { -webkit-transform: translateY(0%)  translateX(0); transform: translateY(0%)  translateX(0); }
	33% { -webkit-transform: translateY(-50%)  translateX(100%); transform: translateY(-50%)  translateX(100%); }
	66% { -webkit-transform: translateY(-90%)  translateX(200%); transform: translateY(-90%)  translateX(200%); }
	100% { -webkit-transform: translateY(-120%)  translateX(350%); transform: translateY(-120%)  translateX(350%); }
 
    
}

@-webkit-keyframes act-8-frames-swim-x
{
0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg);
 
  } 
	50% { 
    -webkit-transform: translateX(5rem) rotateY(0deg); 
    transform: translateX(5rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(5rem) rotateY( -180deg); 
    transform: translateX(5rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  }
   
 
    
}
@keyframes act-8-frames-swim-x
{
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg);
 
  } 
	50% { 
    -webkit-transform: translateX(5rem) rotateY(0deg); 
    transform: translateX(5rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(5rem) rotateY( -180deg); 
    transform: translateX(5rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  }
   
 
    
}

@-webkit-keyframes act-8-frames-swim-guiren-title-x
{
	0% { 
    -webkit-transform:  rotateY(0deg); 
    transform:  rotateY(0deg);
 
  } 
	50% { 
    -webkit-transform:  rotateY(0deg); 
    transform:  rotateY(0deg);
  }
  50.01% { 
    -webkit-transform:  rotateY(180deg); 
    transform:  rotateY( 180deg);
  }
  100% { 
    -webkit-transform:  rotateY(180deg); 
    transform:  rotateY(180deg);
  }
   
 
    
}
@keyframes act-8-frames-swim-guiren-title-x
{
	0% { 
    -webkit-transform: rotateY(0deg); 
    transform:  rotateY(0deg);
 
  } 
	50% { 
    -webkit-transform: rotateY(0deg); 
    transform:  rotateY(0deg);
  }
  50.01% { 
    -webkit-transform:  rotateY(180deg); 
    transform:  rotateY( 180deg);
  }
  100% { 
    -webkit-transform:  rotateY(180deg); 
    transform:  rotateY(180deg);
  }
   
 
    
}
@-webkit-keyframes act-8-frames-swim-y
{

	0% { 
    -webkit-transform: translateY(0)  ; transform: translateY(0) ; 
  }
  50% { 
    -webkit-transform: translateY(-1.5rem) ; transform: translateY(-1.5rem); 
  }
  100% { 
    -webkit-transform: translateY(0) ; transform: translateY(0); 
  } 
}
@keyframes act-8-frames-swim-y
{
	0% { 
    -webkit-transform: translateY(0)  ; transform: translateY(0) ; 
  }
  50% { 
    -webkit-transform: translateY(-1.5rem) ; transform: translateY(-1.5rem); 
  }
  100% { 
    -webkit-transform: translateY(0) ; transform: translateY(0); 
  }
    
}


.act-8-animation-bounce { 
  -webkit-animation: act-8-frames-bounce 2s ease-out infinite; 
  animation: act-8-frames-bounce 2s ease-out infinite;
}
 
.act-8-animation-guiren-swim-x{
  display: block;
  -webkit-animation: act-8-frames-swim-x 20s ease-out infinite; 
  animation: act-8-frames-swim-x 20s ease-out infinite;   
}
.act-8-animation-guiren-swim-guiren-title-x{ 
  display: inline-block;
  -webkit-animation: act-8-frames-swim-guiren-title-x 20s ease-out infinite; 
  animation: act-8-frames-swim-guiren-title-x 20s ease-out infinite;   
}
.act-8-animation-guiren-swim-y{
  display: inline-block;
  -webkit-animation: act-8-frames-swim-y 20s ease-out infinite; 
  animation: act-8-frames-swim-y 20s ease-out infinite;   
}


.act-8-banner-guiren-wrap {
  position: absolute;
  width: 20%;
  left: -20%;
  top: 60%;
}

.act-8-banner-guiren { 
  width: 100%;
}

.page-act8-banner .act-8-banner-guiren-title{ 
  position: absolute;
  top: -48%;
  left: 0;
  width: 60%;
}
/* ACT-8 游泳,桂人 over */ 


/* ACT-8 游泳，柳人 begin */ 
    
@-webkit-keyframes act-8-frames-swim-liuren-x
{
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(-9rem) rotateY(0deg); 
    transform: translateX(-9rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(-9rem) rotateY( -180deg); 
    transform: translateX(-9rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
}  
@keyframes act-8-frames-swim-liuren-x
{
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(-9rem) rotateY(0deg); 
    transform: translateX(-9rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(-9rem) rotateY( -180deg); 
    transform: translateX(-9rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
    
}
   
@-webkit-keyframes act-8-frames-swim-liuren-title-x
{
0% { 
    -webkit-transform: rotateY(0deg); 
    transform: rotateY(0deg);
 
  } 
	50% { 
    -webkit-transform: rotateY(0deg); 
    transform: rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: rotateY(180deg); 
    transform: rotateY(180deg);
  }
  100% { 
    -webkit-transform: rotateY(180deg); 
    transform: rotateY(180deg);
  }  
}  
@keyframes act-8-frames-swim-liuren-title-x
{
0% { 
    -webkit-transform: rotateY(0deg); 
    transform: rotateY(0deg);
 
  } 
	50% { 
    -webkit-transform: rotateY(0deg); 
    transform: rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: rotateY(180deg); 
    transform: rotateY(180deg);
  }
  100% { 
    -webkit-transform: rotateY(180deg); 
    transform: rotateY(180deg);
  }  
    
}

.act-8-animation-swim-liuren-x{
  display: block;
  -webkit-animation: act-8-frames-swim-liuren-x 25s ease-out infinite; 
  animation: act-8-frames-swim-liuren-x 25s ease-out infinite;   
} 
.page-act8-banner .act-8-animation-swim-liuren-title-x{
  display: block;
  -webkit-animation: act-8-frames-swim-liuren-title-x 25s ease-out infinite; 
  animation: act-8-frames-swim-liuren-title-x 25s ease-out infinite;   
} 
.act-8-animation-swim-liuren-y{
  display: block;
  -webkit-animation: act-8-frames-swim-y 25s ease-out infinite; 
  animation: act-8-frames-swim-y 25s ease-out infinite;   
}


.act-8-banner-liuren-wrap {
  position: absolute;
  width: 22%;
  right: -20%;
  top: 106%;
}

.act-8-banner-liuren { 
  width: 100%;
}

.page-act8-banner .act-8-banner-liuren-title{  
  position: absolute;
  top: -58%;
  left: 0;
  width: 60%;
}


@media screen and (max-width: 320px) {
/*background-position-x:   .act-8-banner-liuren-wrap {
    position: absolute;
    width: 22%;
    right: -20%;
    top: 90%;
  }*/
}
/* ACT-8 游泳,桂人 over */ 




/* ACT-8 云 begin */ 
  @-webkit-keyframes act-8-frames-cloud-1
{
	
	
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(-15rem) rotateY(0deg); 
    transform: translateX(-15rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(-15rem) rotateY( -180deg); 
    transform: translateX(-15rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
    
}
  
@keyframes act-8-frames-cloud-1
{

	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(-15rem) rotateY(0deg); 
    transform: translateX(-15rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(-15rem) rotateY( -180deg); 
    transform: translateX(-15rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
}

@-webkit-keyframes act-8-frames-cloud-2
{

	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(-8rem) rotateY(0deg); 
    transform: translateX(-8rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(-8rem) rotateY( -180deg); 
    transform: translateX(-8rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
    
    
}

@keyframes act-8-frames-cloud-2
{
	
	0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(-8rem) rotateY(0deg); 
    transform: translateX(-8rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(-8rem) rotateY( -180deg); 
    transform: translateX(-8rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
    
}


@-webkit-keyframes act-8-frames-cloud-3 {  
0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(8rem) rotateY(0deg); 
    transform: translateX(8rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(8rem) rotateY( -180deg); 
    transform: translateX(8rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
    
}
@keyframes act-8-frames-cloud-3
{
0% { 
    -webkit-transform: translateX(0) rotateY(0deg); 
    transform: translateX(0) rotateY(0deg); 
  }
  50% { 
    -webkit-transform: translateX(8rem) rotateY(0deg); 
    transform: translateX(8rem) rotateY(0deg);
  }
  50.01% { 
    -webkit-transform: translateX(8rem) rotateY( -180deg); 
    transform: translateX(8rem) rotateY( -180deg);
  }
  100% { 
    -webkit-transform: translateX(0) rotateY( -180deg); 
    transform: translateX(0) rotateY( -180deg);
  } 
    
}

.act-8-animation-cloud-1{
  -webkit-animation: act-8-frames-cloud-1 100s ease-out infinite; 
  animation: act-8-frames-cloud-1 100s ease-out infinite; 
}  
 
.act-8-banner-cloud-1 {    
  position: fixed;
  width: 80%;
  right: -88%;
  top: -3%;
  z-index: 2;
}



.act-8-animation-cloud-2{
  -webkit-animation: act-8-frames-cloud-2 200s ease-out infinite; 
  animation: act-8-frames-cloud-2 200s ease-out infinite; 
}  
 
.act-8-banner-cloud-2 {    
  position: fixed;
  width: 30%;
  right: -8%;
  top: 5%;
  z-index: 2;
}



.act-8-animation-cloud-3{
  -webkit-animation: act-8-frames-cloud-3 280s ease-out infinite; 
  animation: act-8-frames-cloud-3 280s ease-out infinite; 
}  
 
.act-8-banner-cloud-3 {     
  position: fixed;
  width: 50%;
  left: -8%;
  top: 5%;
  z-index: 2;
}


/* ACT-8 云 over */ 


/* tower */ 
.tower-wrap{
  position:relative;
}
.tower-wrap .tower{
  width:100%;
}
.mount{
  position:fixed;
  bottom:50px;
  left:0;
  width:100%;
}
/* tower over */ 
</style>


// WEBPACK FOOTER //
// src/components/act/8/Banner.vue